const theme = {
  name: "rbs",
  styles: {
    color: {
      primary: "#72bf44",
      whiteBase: "#ffffff",
      whiteSnow: "#fafafa",
      whiteGrayBase: "#bfbfbf",
      grayBase: "#333333",
      grayDark: "#aaaaaa",
      grayLight: "#d5d5d5",
      grayBright: "#ececec",
      grayNobel: "#9b9b9b",
      grayQuartz: "#dededf",
      grayPlatinum: "#e4e4e4",
      grayWhisper: "#eaeaea",
      grayBackground: "#f8f8f8",
      silverLight: "#efeff4",
      silver: "#c1c1c1",
      grayNightRider: "#353535",
      greyColorLight: "#e4e4e4",
      redBase: "#a6192e",
      redNeutral: "#AE132A",
      redStatus: "#d11c2c",
      redLight: "#ed1f1f",
      mediumBlue: "#2a6dc9",
      blueCornflower: "#4a90e2",
      blueCobalt: "#005cb0",
      disableButton: "#d5d5d5",
      disableIcon: "#eaeaea",
      warmGreyLight: "#e0e0e0",
      blueLight2: "#4a90e2",
      errorRed: "#9f3a38",
      redError: "#d0021b",
      grayBg: "#f8f8f8",
      grayIconDisabled: "#eaeaea",
      regentStBlue: "#96c8da",
      whiteSmoke: "#f7f7f7",
      whiteSmoke2: "#f2f2f2",
      grayDarkNight: "#acacac",
      silverBaseLight: "#b8b8b8",
      blueZodiac: "#404553",
      grayEclipse: "#393939",
      blueBase: "#3b5998",
      errorMsg: "#ed1f1f",
      grayMainDark: "#888888",
      grayMainDark2: "#979797",
      grayMainDark3: "#222222",
      greenLight: "#67ad5b",
      blueLight: "#4a90e1",
      grayMainLight: "#cccccc",
      blackBase: "#000000",
      blackBase20: "rgba(0, 0, 0, 0.2)",
      blackBase50: "rgba(0, 0, 0, 0.5)",
      blackBase80: "rgba(0, 0, 0, 0.8)",
      blackBase85: "rgba(0, 0, 0, 0.85)",
      green: "#67c000",
      greenDark: "#3a8400",
      redErrorMsg: "#e02020",
      yellow: "#f7b500",
      brown: "#4a4a4a",
      blueFocus: "#0457c8",
      blueOxford: "#263238",
      blueDb: "#3498db",
      grayD3: "#d3d3d3",
      greyBase: "#808080",
      lightYellow: "#fff7d5",
    },
    fontSize: {
      sm: "12px",
      base: "14px",
      lg: "16px",
    },
    buttonSize: {
      sm: "36px",
      base: "42px",
      lg: "50px",
    },
    breakpoints: { xs: 0, sm: 576, md: 769, lg: 1024, xl: 1200 },
    mediaScreen: {
      mobile: "479px",
      tablet: "991px",
      tabletVertical: "768px",
      desktopScreen: "769px",
      desktop: "991px",
      desktopMedium: "1199px",
      desktopLarge: "1300px",
    },
    layout: {
      gap: "15px",
      maxContentWidth: "1440px",
    },
  },
  global: {
    cmsBlocks: {
      search_bar_placeholder: "search_bar_placeholder",
      bottom_title_content_left: "bottom_title_content_left",
      bottom_content_left: "bottom_content_left",
      bottom_title_content_middle: "bottom_title_content_middle",
      bottom_content_middle: "bottom_content_middle",
      bottom_title_content_right: "bottom_title_content_right",
      bottom_content_right: "bottom_content_right",
      footer_reference_section_desktop: "footer_reference_section_desktop",
      footer_reference_section_mobile: "footer_reference_section_mobile",
      footer_copyright_section: "footer_copyright_section",
      footer_contacts_section: "footer_contacts_section",
      footer_download_app_section: "footer_download_app_section",
      footer_help_section: "footer_help_section",
      footer_services_section: "footer_services_section",
      footer_stores_section: "footer_stores_section",
      footer_about_central_section: "footer_about_central_section",
      contacts_section: "contacts_section",
    },
    banners: {
      homepage_running_text: "homepage_running_text",
    },
  },
  page: {
    homepage: {
      cmsBlocks: {
        why_us_section: "why_us_section",
        bank_banner_section_mobile: "bank_banner_section_mobile",
        bank_banner_section_desktop: "bank_banner_section_desktop",
      },
      banners: {
        homepage_hero_banner: "homepage_hero_banner",
        homepage_hero_banner_mobile: "homepage_hero_banner_mobile",
        homepage_promotion: "homepage_promotion",
        homepage_central_inspirer: "homepage_central_inspirer",
        homepage_in_store_event: "homepage_in_store_event",
      },
    },
    information: {
      page_help_about_us: "page_help_about_us",
      page_help_how_to_shop: "page_help_how_to_shop",
      page_help_how_to_track_order: "page_help_how_to_track_order",
      page_help_how_to_pay: "page_help_how_to_pay",
      page_help_how_to_return: "page_help_how_to_return",
      page_help_general_faqs: "page_help_general_faqs",
      page_help_in_store_faqs: "page_help_in_store_faqs",
      page_help_installment_faqs: "page_help_installment_faqs",
      page_service_point_redemption: "page_service_point_redemption",
      page_service_delivery_policy: "page_service_delivery_policy",
      page_service_click_and_collect: "page_service_click_and_collect",
      page_service_return_policy: "page_service_return_policy",
      page_service_gift_wrapping: "page_service_gift_wrapping",
      page_stores_store_locator: "page_stores_store_locator",
      page_stores_store_promotion: "page_stores_store_promotion",
      page_stores_chat_and_shop: "page_stores_chat_and_shop",
      page_service_chat_and_shop: "page_service_chat_and_shop",
      page_stores_tourist_guide: "page_stores_tourist_guide",
      page_help_term_cond: "page_help_term_cond",
      page_help_contact_us_header: "page_help_contact_us_header",
    },
  },
  translate: {
    th: {
      only_at_central: "โรบินสัน เอ็กซ์คลูซีฟ",
      only_at_central_tags: "ONLY@ROBINSON",
      central_inspirer: "Inspiration",
      why_shop_with_us: "ตอบโจทย์ทุกการช้อปที่โรบินสัน",
      sold_by_default: "Robinson",
      company_name: "โรบินสัน",
      category: {
        inspirer: "robinson inspirer",
      },
      footer: {
        about_company_section: "เกี่ยวกับโรบินสัน",
      },
      login: {
        title: "เข้าสู่ระบบด้วยบัญชีโรบินสัน",
        guest_new_member: "สำหรับสมาชิกใหม่",
      },
      register: {
        success_subTitle: "ยินดีต้อนรับเข้าสู่เว็บไซต์โรบินสัน",
      },
      forget_password: {
        sub_title: "สร้างรหัสผ่านใหม่เพื่อเข้าถึงบัญชีของคุณ",
      },
      mobile_menu: {
        account_title: "บัญชีของฉัน",
      },
      guest_order: {
        create_account_title: "สมัครสมาชิก ROBINSON ตอนนี้",
      },
      payment_method: {
        remark_pay2c2p:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_pay123:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_payIpp:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_samsung_pay:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_line_pay:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
      },
      filter_label: {
        color_group_name: "สี",
        size: "ไซส์",
        shoe_sizes: "ขนาดรองเท้า",
        gender_1: "เพศ",
        material_clothing: "วััสดุเสื้อผ้า",
        shoe_material: "วัสดุรองเท้า",
        material_general: "วัสดุุ",
        is_sets: "ชุด",
        elect_power_watt: "กำลังไฟฟ้า",
        age_range: "ช่วงอายุ",
        anti_calc_clean: "ระบบขจัดคราบตะกรัน",
        app_connected: "ระบบเชื่อมต่อกับแอปพลิเคชัน",
        battery_time: "อายุการใช้งานแบต",
        battery_type: "ประเภทแบตเตอรรี่",
        boil_function: "ฟังก์ชั่นการต้ม",
        bottle_size: "ขนาดขวด",
        accessory_bracelet_size: "ขนาดกำไล",
        btu: "บีทียู",
        capacity_grams: "ความจุ (กรัม)",
        capacity_lts: "ความจุ (ลิตร)",
        car_seat_age: "ช่วงอายุ (คาร์ซีท)",
        home_clock_type: "ประเภทนาฬิกา",
        coffee_maker_technology: "ระบบเทคโนโลยีเครื่องชงกาแฟ",
        cordless: "ไร้สาย",
        descaling_system: "ระบบขจัดคราบตะกรัน",
        material_dial: "วัสดุหน้าปัด",
        diaper_size: "ขนาดผ้าอ้อม",
        kid_diaper_type: "ประเภทผ้าอ้อม",
        diaper_weight: "น้ำหนักผ้าอ้อม",
        digital_manual: "ระบบดิจิตอล/แมนนวล",
        filtration: "ระบบการกรองน้ำ",
        grill_mode: "โหมดย่าง",
        fashion_heel_type: "ประเภทส้นรองเท้า",
        inverter: "อินเวอร์เตอร์",
        inverter_type: "ประเภทอินเวอร์เตอร์",
        accessory_jewelry_type: "ประเภทจิวเวอรี่",
        life_luggage_size: "ขนาดกระเป๋าเดินทาง",
        life_luggage_type: "ประเภทกระเป๋าเดินทาง",
        microphone: "ไมโครโฟน",
        milk_powder_formula: "สูตรนมผง",
        milk_powder_type: "ประเภทนมผง",
        necklace_size: "ขนาดสร้อยคอ",
        fashion_neckline: "คอเสื้อ",
        fashion_occasion: "โอกาส",
        pacifier_size: "ขนาดจุกนม",
        fashion_pant_fit: "ทรงกางเกง",
        pattern: "ลวดลาย",
        pm25: "PM2.5",
        racket: "แร็กเกต",
        ro: "RO",
        room_size_sqm: "ขนาดห้อง (ตรม.)",
        fashion_shoes_type: "ประเภทรองเท้า",
        fashion_sleeves_level: "ระดับแขนเสื้อ",
        fashion_socks_type: "ประเภทถุงเท้า",
        style_general: "สไตล์",
        fashion_swimwear_type: "ประเภทชุดว่ายน้ำ",
        fashion_underwear_type: "ประเภทชุุดชั้นใน",
        waterproof: "กันน้ำ",
        weight_kg: "น้ำหนัก (กิโลกรัม)",
        wireless: "ไร้สาย",
        density: "ความหนาแน่น (กรัม)",
        dress_length: "ความยาวชุดกระโปรง",
        filters: "ฟิลเตอร์",
        price_range: "ช่วงราคา",
        sort: "เรียง",
        asc: "ต่ำ-สูง",
        desc: "สูง-ต่ำ",
        recommended: "สินค้าแนะนำ",
        new_arrival: "สินค้ามาใหม่",
        price: "ราคา",
        price_discount: "ส่วนลด",
        brand_name: "Brand Name",
        shipping_delivery_methods_delivery_method: "ตัวเลือกการจัดส่ง",
        show_more: "ดูเพิ่มเติม",
        show_less: "ดูน้อยลง",
        rating: "รีวิวจากลูกค้า",
      },
    },
    en: {
      only_at_central: "Robinson Exclusive",
      only_at_central_tags: "ONLY@ROBINSON",
      central_inspirer: "Inspiration",
      why_shop_with_us: "Why shop with us",
      sold_by_default: "Robinson",
      company_name: "Robinson",
      category: {
        inspirer: "robinson inspirer",
      },
      footer: {
        about_company_section: "About Robinson",
      },
      login: {
        title: "Log in to Robinson account",
        guest_new_member: "NEW TO ROBINSON ONLINE?",
      },
      register: {
        success_subTitle: "Welcome to the Robinson Departmental Store website.",
      },
      forget_password: {
        sub_title: "Create new password to access your Robinson account",
      },
      mobile_menu: {
        account_title: "Your Robinson Account",
      },
      guest_order: {
        create_account_title: "CREATE YOUR ROBINSON ACCOUNT NOW",
      },
      payment_method: {
        remark_pay2c2p:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_pay123:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_payIpp:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_samsung_pay:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
        remark_line_pay:
          "By clicking on Pay Now, you will be directed to Robinson's Payment gateway partner",
      },
      filter_label: {
        color_group_name: "Color",
        size: "Size",
        shoe_sizes: "Shoe size",
        gender_1: "Gender",
        material_clothing: "Clothing Material",
        shoe_material: "Shoe Material",
        material_general: "Material",
        is_sets: "Sets",
        elect_power_watt: "Watt",
        age_range: "Age Range",
        anti_calc_clean: "Anti-calc clean",
        app_connected: "App connected",
        battery_time: "Battery time",
        battery_type: "Battery type",
        boil_function: "Boil Function",
        bottle_size: "Bottle Size",
        accessory_bracelet_size: "Bracelet Size",
        btu: "BTU",
        capacity_grams: "Capacity Grams",
        capacity_lts: "Capacity lts.",
        car_seat_age: "Car Seat Age",
        home_clock_type: "Clock Type",
        coffee_maker_technology: "Coffee Maker Technology",
        cordless: "Cordless",
        descaling_system: "Descaling System",
        material_dial: "Dial Material",
        diaper_size: "Diaper Size",
        kid_diaper_type: "Diaper Type",
        diaper_weight: "Diaper Weight",
        digital_manual: "Digital / manual",
        filtration: "Filtrations",
        grill_mode: "Grill Mode",
        fashion_heel_type: "Heel Type",
        inverter: "Inverter",
        inverter_type: "Inverter Type",
        accessory_jewelry_type: "Jewelry Type",
        life_luggage_size: "Luggage Size",
        life_luggage_type: "Luggage Type",
        microphone: "Microphone",
        milk_powder_formula: "Milk Powder formula",
        milk_powder_type: "Milk Powder Type",
        necklace_size: "Necklace Size",
        fashion_neckline: "Neckline",
        fashion_occasion: "Occasion",
        pacifier_size: "Pacifiers Size",
        fashion_pant_fit: "Pant Fit",
        pattern: "Pattern",
        pm25: "PM2.5",
        racket: "Racket",
        ro: "RO",
        room_size_sqm: "Room Size (SQM)",
        fashion_shoes_type: "Shoe Type",
        fashion_sleeves_level: "Sleeves Level",
        fashion_socks_type: "Sock Type",
        style_general: "Style",
        fashion_swimwear_type: "Swimwear Type",
        fashion_underwear_type: "Underwear Type",
        waterproof: "Waterproof",
        weight_kg: "Weight Kg.",
        wireless: "Wireless",
        density: "Density (g.)",
        dress_length: "Dress Length",
        filters: "Filters",
        price_range: "Price Range",
        sort: "Sort",
        asc: "Low-High",
        desc: "High-Low",
        recommended: "Recommended",
        new_arrival: "New Arrivals",
        price: "Price",
        price_discount: "Discount",
        brand_name: "Brand Name",
        shipping_delivery_methods_delivery_method: "Available Delivery Options",
        show_more: "Show more",
        show_less: "Show less",
        rating: "Customer Rating",
      },
    },
  },
  configs: {
    consentPartner: "RBS",
    t1cUrlParam: "&utm_source=cds&utm_medium=link&utm_campaign=centralonline",
    innerHtmlHome:
      '{"@context":"https://schema.org","@type":"Organization","name":"robinson.co.th","url":"https://www.robinson.co.th/th/","logo":"https://www.robinson.co.th/images/logo.png","contactPoint":[{"@type":"ContactPoint","telephone":"(+66)02-808-5555","contactType":"customer service","availableLanguage":["Thai"," English"],"contactOption":[]}],"sameAs":["https://www.facebook.com/robinsononline/","https://www.instagram.com/robinsondepartmentstore/?hl=th","https://www.youtube.com/channel/UCSe3sf51fnQviM_j2p4pmdg" ,"https://line.me/ti/p/@robinson"]}',
    site_name: "Robinson Online Shopping",
    twitter: "@robinsonnews",
    encryptOrderId: "central-success-page-secret-string",
    fixCategories: [
      "health-beauty",
      "home-living",
      "sports-leisure",
      "gadgets-electronics",
      "mom-kids",
      "women-fashion",
      "men-unisex",
      "bags-accessories",
    ],
    extraCategories: [
      { type: "brand", key: "brand", url: "shopbybrand" },
      { type: "sale", key: "sales-promotion", url: "sales-promotion" },
      { type: "gifts", key: "gifts", url: null },
    ],
    filterKeys: [
      "color_group_name",
      "size",
      "shoe_sizes",
      "gender_1",
      "material_clothing",
      "shoe_material",
      "material_general",
      "is_sets",
      "elect_power_watt",
      "age_range",
      "anti_calc_clean",
      "app_connected",
      "battery_time",
      "battery_type",
      "boil_function",
      "bottle_size",
      "accessory_bracelet_size",
      "btu",
      "capacity_grams",
      "capacity_lts",
      "car_seat_age",
      "home_clock_type",
      "coffee_maker_technology",
      "cordless",
      "descaling_system",
      "material_dial",
      "diaper_size",
      "kid_diaper_type",
      "diaper_weight",
      "digital_manual",
      "filtration",
      "grill_mode",
      "fashion_heel_type",
      "inverter",
      "inverter_type",
      "accessory_jewelry_type",
      "life_luggage_size",
      "life_luggage_type",
      "microphone",
      "milk_powder_formula",
      "milk_powder_type",
      "necklace_size",
      "fashion_neckline",
      "fashion_occasion",
      "pacifier_size",
      "fashion_pant_fit",
      "pattern",
      "pm25",
      "racket",
      "ro",
      "room_size_sqm",
      "fashion_shoes_type",
      "fashion_sleeves_level",
      "fashion_socks_type",
      "style_general",
      "fashion_swimwear_type",
      "fashion_underwear_type",
      "waterproof",
      "weight_kg",
      "wireless",
      "density",
      "dress_length",
    ],
    socialNetwork: [
      {
        icon: "/icons/socials/facebook.svg",
        href: "https://www.facebook.com/robinsononline/",
      },
      {
        icon: "/icons/socials/youtube.svg",
        href: "https://www.youtube.com/user/RobinsonDepartment",
      },
      {
        icon: "/icons/socials/instagram.svg",
        href: "https://www.instagram.com/robinsondepartmentstore/",
      },
      {
        icon: "/icons/socials/line.svg",
        href: "https://line.me/R/ti/p/%40robinsononline",
      },
    ],
    returnDocumentLink_TH:
      "https://drive.google.com/file/d/14UNlnO3aiIH_f20Q5xp_rIu0WAKlMUO2/view",
    returnDocumentLink_EN:
      "https://drive.google.com/file/d/1rc2ffdywf3EGbLlJ68B54UBdG67fIzQa/view",
    isYouMayLikeAllCategory: true,
    dataLake: {
      enableSearchRedirect: false,
    },
    domain: {
      frontend: "https://*.robinson.co.th",
      falcon: "https://*.robinson.co.th",
    },
    googleSiteVerification: "PUj44bYNlhTixAwaRMRtd0puCC0xSoIoEsWHOc1Tm8M",
    badgePickupLabel: "2hr",
    enabled3hr: false,
  },
  killSwitch: {
    checkout: {
      storePickup: true,
      bankTransferUI: false,
    },
    postPurchase: {
      flag_pop_order_tracking_page: false,
      flag_pop_order_history_page: true,
    },
    discovery: {
      isEnableSearchResultV2: false,
      flag_dsc_std_brand_landing: false,
      flag_dsc_product_slider: false,
      flag_dsc_category_lvl_34: false,
      flag_dsc_std_brand_plp: false,
      flag_dsc_normal_brand: false,
    },
  },
};

export default theme;
